var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgUpi = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 34,
  viewBox: "0 0 24 34",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M6 34L15.4827 0L24 16.9993L6 34Z",
  fill: "white"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M0 34L9.4827 0L18 16.9993L0 34Z",
  fill: "white"
})));
export { SvgUpi as ReactComponent };
export default __webpack_public_path__ + "assets/icons/upi.6299af.svg";